import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useContext, useMemo } from 'react';
import ConditionalTile from '~/constants/srp/ConditionalTile';
import { useFavoritesIds } from '~/context/common/UserContext';
import InventoryContext from '~/context/srp/InventoryContext';
import type { InventoryConditionalTile } from '~/contracts/srp';
import useIsOpenSearch from '~/hooks/srp/selectors/useIsOpenSearch';
import { injectConditionalTiles } from '~/hooks/srp/useConditionalTiles';

export default function useTiles(): Array<
  InventoryVehicle | InventoryConditionalTile
> {
  const { inventory } = useContext(InventoryContext);
  const favoritesIds = useFavoritesIds();
  const isOpenSearch = useIsOpenSearch();

  return useMemo<Array<InventoryVehicle | InventoryConditionalTile>>(() => {
    if (!inventory.isLoaded || !inventory.data.inventory.vehicles.length) {
      return [];
    }

    const tileData = inventory.data.inventory.vehicles.map<InventoryVehicle>(
      vehicle => ({
        ...vehicle,
        isFavorite: favoritesIds.some(v => v === vehicle.vehicleId)
      })
    );
    const conditionalTileData = (
      inventory.data.inventory.conditionalTiles || []
    ).filter(
      tile => !(isOpenSearch && tile.key === ConditionalTile.NewCarConfigurator)
    );

    return injectConditionalTiles(tileData, conditionalTileData);
  }, [
    favoritesIds,
    inventory.data.inventory.conditionalTiles,
    inventory.data.inventory.vehicles,
    inventory.isLoaded,
    isOpenSearch
  ]);
}
